<template>
  <PartnerInfoSection
    :localPartner="localPartner"
    @partner:updated="emitPartnerUpdated"
  />

  <hr>

  <CreditLimitSection
    v-if="(localPartner.isBuyer && localPartner.id === $core.currentUser.partner.id)
      || ($core.currentUser.isPrivileged && localPartner.isBuyer)"
    :local-partner="localPartner"
    @partner:updated="emitPartnerUpdated"
  />

  <hr>

  <StoresSection
    :localPartner="localPartner"
    @stores:updated="emitPartnerUpdated"
  />

  <hr>

  <CompaniesSection
    :localPartner="localPartner"
    @companies:updated="emitPartnerUpdated"
  />

  <hr>

  <BankAccountsSection
    :localPartner="localPartner"
    @bank-accounts:updated="emitPartnerUpdated"
  />

  <hr>

  <ContractsSection
    :localPartner="localPartner"
    @contracts:updated="emitPartnerUpdated"
  />

  <hr>
</template>

<script lang="ts">

import Partner             from "@/domains/Partners/Partner";

import StoresSection       from "@/domains/Stores/components/StoresSection/StoresSection.vue";
import ContractsSection    from "@/domains/Contracts/components/ContractsSection/ContractsSection.vue";
import CompaniesSection    from "@/domains/Companies/components/CompaniesSection/CompaniesSection.vue";
import BankAccountsSection from "@/domains/BankAccounts/components/BankAccountsSection/BankAccountsSection.vue";
import PartnerInfoSection  from "@/domains/Partners/components/PartnerCard/PartnerEditSection/PartnerInfoSection.vue";
import CreditLimitSection  from "@/domains/Partners/components/PartnerCard/PartnerEditSection/CreditLimitSection.vue";

export default defineComponent({
	name: "PartnerMainSection",

	components: {
		CreditLimitSection,
		StoresSection,
		PartnerInfoSection,
		BankAccountsSection,
		CompaniesSection,
		ContractsSection,
	},

	props: {
		localPartner: {
			type: Partner,
			default: null,
		}
	},

	emits: ['partner:updated'],

	methods: {
		emitPartnerUpdated() {
			this.$emit('partner:updated');
		},
	}
})
</script>